/* global axios */
import ApiClient from './ApiClient';

class OperationalMetricsApi extends ApiClient {
  constructor() {
    super('operational_metrics', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new OperationalMetricsApi();
